import React, { useEffect, useState } from "react";

import { Layout } from "antd";
import MainMenu  from "./MainMenu";
import NavBar    from "./Navbar";
import SideBar   from "./Sidebar";

import { Routes, Route, useNavigate  } from 'react-router-dom';

import {DashboardRoutes, ReportRoutes, ProfileRoutes} from "../../../routes/DashboardRoutes";

import "../../../assets/css/test.css"

import { useLocation  } from 'react-router-dom'

import { validateSessionID } from '../../../store/api/auth.api'

import userStore from  "../../../store/slice/auth.slice"

import { message } from 'antd'

import Logout from '../../auth/logout'

function Main() {
    
    const navigate = useNavigate()
    const location = useLocation()

    const [selectedKey, setSelectedKey] = useState("0");
    const [logout, setlogout]           = useState(false)
    //const userData  = userStore((state) => state.response)

    const changeSelectedKey = (event) => {
        const key = event.key;
        setSelectedKey(key);
    }

    const currentPathname = location.pathname

    let DRoute = []

    if(currentPathname.includes('/branchDetails')){
        DRoute = DashboardRoutes
        DRoute = DRoute.concat(ReportRoutes)
    }else{
        DRoute = DashboardRoutes
    }

    DRoute = DRoute.concat(ProfileRoutes)
    
    const Menu = (
        <MainMenu
            menus={DRoute}
            selectedKey={selectedKey}
            changeSelectedKey={changeSelectedKey}
        />
    )

    const userDetails = JSON.parse(localStorage.getItem('userDetails'))

    const checkSession = async () => {

        let userLocal = JSON.parse(localStorage.getItem('userDetails'))
        
        if(userLocal != null && userLocal.session_id != null && userLocal.session_id != ''){

            const validateSession = await validateSessionID(userLocal.session_id, userLocal.email)

            if(validateSession.data.response_code != '01'){
                message.warning({
                    maxCount: 1,
                    duration: 2.5,
                    content: validateSession.data.message,
                    key: 'logoutmessage'
                })

                setTimeout( ()=>{ setlogout(true) }, 250)
            }
        }else{
            setlogout(true)
        }
    }

    checkSession();

    setInterval( () => {
        checkSession()
    //}, 50000);
    }, 50000);

    useEffect(()=>{
        if(logout){
            navigate('/auth/logout')
        }
    }, [logout, navigate])

    return (
        <div className="App">  
            <NavBar menu={Menu} username={userDetails.username} />

            <Layout>
                <SideBar menu={Menu} />

                <Layout.Content className="content">

                    <div className="site-layout-background">
                        <Routes>
                            {DRoute.map((item, index) => {
                                return  (<Route exact={item.exact} path={item.path} element={item.component} key={item.id} />)
                            })}

                            {DRoute.map((item, index) => {
                                return  (<Route exact={item.exact} path={item.path} element={item.component} key={item.id} />)
                            })}

                            <Route exact path='*' element={<Logout/>}/>
                        </Routes>
                    </div>

                    <Layout.Footer style={{ textAlign: 'center'}}>
                        Jubilee Life Insurance ©2022
                    </Layout.Footer>

                </Layout.Content>
            </Layout>

        </div>
    )
}
export default Main;